import { CONTACT } from "../lib/brand";
import { IconWhatsApp, IconInstagram, IconMapPin } from "./icons";
import { ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

const SOCIAL = [
  { key: "whatsapp", href: CONTACT.whatsapp, label: "WhatsApp", Icon: IconWhatsApp },
  { key: "instagram", href: CONTACT.instagram, label: "Instagram", Icon: IconInstagram },
];

const EXPLORE = [
  { to: "/proposito", label: "Propósito" },
  { to: "/sobre", label: "Sobre Herida" },
  { to: "/servicos", label: "Serviços" },
  { to: "/produtos", label: "Produtos" },
  { to: "/loja", label: "Loja" },
  { to: "/depoimentos", label: "Depoimentos" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-ink-800 text-cream/80 py-14 sm:py-20"
    >
      <div className="mx-auto max-w-[1600px] px-6 sm:px-10">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 md:col-span-4">
            <div className="font-serif italic text-cream text-4xl">
              desapegue
            </div>
            <div className="mt-2 font-mono text-[10px] uppercase tracking-[0.3em] text-cream/60">
              com Herida — Desapega · Renova · Transforma
            </div>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-cream/50 mb-4">Explore</div>
            <ul className="space-y-2 font-serif italic text-lg">
              {EXPLORE.map((e) => (
                <li key={e.to}>
                  <Link className="link-under" to={e.to}>
                    {e.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-12 md:col-span-5">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-cream/50 mb-4">
              Onde me encontrar
            </div>
            <a
              href={CONTACT.maps}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-address-map"
              className="group flex items-start gap-5 border border-cream/20 hover:border-cream hover:bg-cream/5 transition-colors duration-500 p-5"
            >
              <span className="mt-1 w-11 h-11 flex items-center justify-center border border-cream/30 group-hover:border-cream group-hover:bg-cream group-hover:text-ink-800 text-cream transition-colors duration-500 flex-shrink-0">
                <IconMapPin size={18} strokeWidth={1.6} />
              </span>
              <span className="flex flex-col">
                <span className="font-serif italic text-2xl text-cream leading-tight">
                  {CONTACT.address.street}
                </span>
                <span className="mt-1 font-sans text-sm text-cream/80">
                  {CONTACT.address.neighborhood} · {CONTACT.address.city}
                </span>
                <span className="mt-4 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.3em] text-cream/70 group-hover:text-cream transition-colors duration-500">
                  Abrir no Google Maps
                  <span className="group-hover:translate-x-1 transition-transform duration-500">→</span>
                </span>
              </span>
            </a>

            <div className="mt-6 flex items-center gap-3">
              {SOCIAL.map((s) => (
                <a
                  key={s.key}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={s.label}
                  data-testid={`footer-${s.key}`}
                  className="w-11 h-11 border border-cream/25 hover:border-cream hover:bg-cream hover:text-ink-800 text-cream/80 flex items-center justify-center transition-colors duration-500"
                >
                  <s.Icon size={18} strokeWidth={1.6} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-cream/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 font-mono text-[10px] uppercase tracking-[0.3em] text-cream/50">
          <span>© MMXXVI · desapegue com Herida</span>
          <span>Um propósito de moda circular</span>
          <span className="inline-flex items-center gap-3">
            <span>Desenvolvido por Sapientia Consultores Associados</span>
            <a
              href="https://www.sapientia.net.br/"
              target="_blank"
              rel="noreferrer"
              aria-label="Sapientia Consultores Associados"
              data-testid="footer-sapientia"
              className="inline-flex items-center justify-center w-8 h-8 border border-cream/25 hover:border-cream hover:bg-cream hover:text-ink-800 text-cream/70 transition-colors duration-500"
            >
              <ExternalLink size={13} strokeWidth={1.7} />
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
